import { Typography } from "@mui/material";
import { ExternalAccessStatus } from "../../../Core/Api/Types/access-models";
import TableCellExpiresIn from "../../Table/TableCellExpiresIn/table-cell-expires-in";
import { getExpirationDaysFromString } from "../../../Utils/helpers";

export const ExternalAccessExpiresOnDate = (props: { dateString: string; status: ExternalAccessStatus }) => {
  const { dateString, status } = props;
  const nbDays = getExpirationDaysFromString(dateString);
  return <ExternalAccessExpiresIn nbDays={nbDays} status={status} />;
};

export const ExternalAccessExpiresIn = (props: { nbDays: number; status: ExternalAccessStatus }) => {
  const { nbDays, status } = props;

  return (
    <>
      {status === ExternalAccessStatus.Pending || status === ExternalAccessStatus.Active ? (
        <TableCellExpiresIn daysNumber={nbDays} />
      ) : (
        <Typography>-</Typography>
      )}
    </>
  );
};
